import React from "react";


const ShippingandDelivery = () => {
    return (
        <>
            <section class="blog about-blog">
                <div class="container">
                    {/* <div class="blog-bradcrum">
                        <span><a href="/home">Home</a></span>
                        <span class="devider">/</span>
                        <span><a href="#">Terms and Condition</a></span>
                    </div> */}
                    <div class="blog-heading about-heading">
                        <h1 class="heading">Shipping and Delivery</h1>
                    </div>
                </div>
            </section>

            <section class="product privacy footer-padding">
                <div class="container">
                    <div class="privacy-section">
                    <div class="policy">
                    
                            <p class="policy-details">Please read these shipping and delivery policies here before using www.grocji.com website or the associated mobile apps operated by Grocji.</p>
                        </div>

                        <div class="policy">
                            <h5 class="intro-heading">Shipping & Delivery</h5>
                            <p class="policy-details">We’re committed to getting your order to you as quickly and safely as possible.</p>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">Shipping Options & Timeframes</h5>
                            <p class="policy-details">Domestic Shipping (Within India) - Standard Shipping: Max 1-3 Days.
                            </p>
                            <div class="policy-features">
                                <h5 class="intro-heading">Order Tracking</h5>
                                <p class="policy-details">Once your order is placed, you’ll receive an order id. You can also track your order using the order id.
                            </p>
                            </div>
                        </div>
                        <div class="policy">
                            <h5 class="intro-heading">Delivery Policy</h5>
                            <p class="policy-details">Delivery may be delayed in remote areas or due to holidays or weather conditions. In case of delivery issues, our support team is always here to help.</p>
                        </div>
                        
                        <div class="policy">
                            <h5 class="intro-heading">Contact Details</h5>
                            <p class="policy-details">Email - grocjicontact@gmail.com | Mobile - 8757499345</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default ShippingandDelivery;